import { render, staticRenderFns } from "./NewPlatform.vue?vue&type=template&id=7f4de814&lang=pug&"
import script from "./NewPlatform.vue?vue&type=script&lang=js&"
export * from "./NewPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports